import './Modal.scss'

import { useModal } from '../../../contexts/Modal'
import Backdrop from '../Backdrop/Backdrop'
import { useForm } from '../../../contexts/Form'
import { useEffect } from 'react'

const Modal = ({}) => {
    const modal = useModal()
    const formContext = useForm()
    const formName = modal.$state?.formName
    const form = formName && formContext.$state[formName]

    const closeModalOnEsc = (event) => {
        if (event.key === 'Escape' || event.key === 'Esc') {
            event.preventDefault()
            modal.close()
        }
    }

    useEffect(() => {
        if (modal.$state?.component) document.addEventListener('keydown', closeModalOnEsc)
        else document.removeEventListener('keydown', closeModalOnEsc)

        return () => document.removeEventListener('keydown', closeModalOnEsc)
    }, [modal.$state?.component])

    return (
        <>
            {modal.$state && (
                <>
                    <Backdrop onClick={modal.close} />
                    <aside className={`modal flex-column ${modal.$state.size}`}>
                        <h1 className="title">{modal.$state.title}</h1>

                        {form ? (
                            <form className="row flex-column h-100" onSubmit={form.onSubmit}>
                                <main className="col body my-5">
                                    {modal.$state.component}
                                </main>

                                <footer className="col-auto">
                                    <div className="row justify-content-between">
                                        <div className="col-auto mr-auto">
                                            <button type="button" className="primary outline large" onClick={modal.close}>Cancel</button>
                                        </div>

                                        {modal.$state.actions?.map((action) => (
                                            <div className="col-auto" key={action.label}>
                                                <button type="button" className={`${action.type || 'primary'} large`} disabled={action.disabled && action.disabled()} onClick={action.onClick}>
                                                    <span>{action.label}</span>
                                                </button>
                                            </div>
                                        ))}

                                        <div className="col-auto">
                                            <button type="submit" className="primary large" disabled={form.invalid}>{modal.$state.submitLabel}</button>
                                        </div>
                                    </div>
                                </footer>
                            </form>
                        ) : (
                            <div className="row flex-column h-100">
                                <main className="col body my-5">
                                    {modal.$state.component}
                                </main>
                                
                                <footer className="col-auto">
                                    <div className="row">
                                        <div className="col-auto mr-auto">
                                            <button type="button" className="primary outline large" onClick={modal.close}>Cancel</button>
                                        </div>

                                        {modal.$state.actions?.map((action) => (
                                            <div className="col-auto" key={action.label}>
                                                <button type="button" className={`${action.type || 'primary'} large`} disabled={action.disabled && action.disabled()} onClick={action.onClick}>
                                                    <span>{action.label}</span>
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </footer>
                            </div>
                        )}
                    </aside>
                </>
            )}
        </>
    )
}

export default Modal